import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { FAQAccordion } from 'routes/components/Shared/Accordion'
import { pricingFaqData } from './pricingFaqData'
import classes from './PricingFAQ.module.scss'

export const PricingFAQ = () => {
  return (
    <Block
      as={'section'}
      variant={'solidMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
        Frequently Asked Questions
      </Heading>

      <FAQAccordion array={pricingFaqData} />
    </Block>
  )
}
